import { render, staticRenderFns } from "./MiraTrendCard.vue?vue&type=template&id=4a2ee7de&scoped=true&"
import script from "./MiraTrendCard.vue?vue&type=script&lang=ts&"
export * from "./MiraTrendCard.vue?vue&type=script&lang=ts&"
import style0 from "./MiraTrendCard.vue?vue&type=style&index=0&id=4a2ee7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ee7de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VSpacer})
